import { Link } from 'react-router-dom';
import styled, { DefaultTheme, css } from 'styled-components/macro';

import Button from 'components/Button/Button';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ReportStateStyledT = {
  isReportOpened: boolean;
};

export const MainHeaderWrapStyled = styled.div`
  position: relative;
  width: 100%;
`;

export const InnerContentStyled = styled(FlexContainer)`
  align-self: baseline;
  gap: 10px;
  width: 100%;
  margin-bottom: 10px;
`;

export const ClaimReportInnerContentStyled = styled(InnerContentStyled)`
  gap: 3px;
  > div:not(:first-child) {
    margin-bottom: 9px;
  }
`;

export const GradesWrapStyled = styled.div`
  flex-shrink: 0;
`;

export const GradeLabelStyled = styled(Typography)`
  font-size: 0.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
  opacity: 0.3;
`;

export const FooterWrapStyled = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  min-height: 38px;
  background: ${({ theme }) => theme.colors.primary.variant3};
  padding: 7px 9px;
  border-radius: ${({ theme }) => theme.radius.lg};
`;

export const HeaderStyled = styled(FlexContainer)<ReportStateStyledT>`
  position: relative;
  flex-direction: column-reverse;
  gap: 0.5rem;
  align-items: end;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  transition: margin-bottom 0.3s linear;
  z-index: 1;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      flex-direction: row;
      gap: 2rem;
      align-items: center;
    }
  `}
`;

export const FlexContainerStyled = styled(FlexContainer)`
  gap: 0.75rem;
  margin-left: auto;
`;

export const ButtonCollapseStyled = styled(ButtonIcon)<ReportStateStyledT>`
  height: 26px;

  svg {
    transform: rotate(${({ isReportOpened }) => (isReportOpened ? '180deg' : '0')});
    transition: 0.3s;
  }

  &:hover {
    svg {
      transform: rotate(${({ isReportOpened }) => (isReportOpened ? '0' : '180deg')});
    }
  }
`;

export const HelpBtnIconStyled = styled(ButtonIcon)`
  padding: 0;
`;

export const getPopupContentStyle = (theme: DefaultTheme, isMobile: boolean) => ({
  minWidth: isMobile ? '180px' : '145px',
  borderRadius: theme.radius.sm,
});

export const MenuItemStyled = styled.li`
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
  }

  &:only-of-type {
    border-radius: ${({ theme }) => `${theme.radius.sm}`};
  }

  &:not(:only-of-type) {
    &:first-of-type {
      border-radius: ${({ theme }) => `${theme.radius.sm} ${theme.radius.sm} 0 0`};
    }

    &:last-of-type {
      border-radius: ${({ theme }) => `0 0 ${theme.radius.sm} ${theme.radius.sm}`};
    }
  }
`;

const baseNavControl = css`
  width: 100%;
  height: auto;
  justify-content: flex-start;
  padding: 1rem 0.875rem;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize['2xl']};
`;

export const MenuBtnStyled = styled(Button)`
  ${baseNavControl}

  ${({ theme }) => `
    ${theme.devices.tablet} {
      font-size: ${theme.fontSize.md};
      padding: 0.875rem;
    }
  `}
`;

export const LinkStyled = styled(Link)`
  ${baseNavControl}

  display: inline-flex;
  color: ${({ theme }) => theme.colors.primary.variant1};

  ${({ theme }) => `
    ${theme.devices.tablet} {
      font-size: ${theme.fontSize.md};
      padding: 0.875rem;
    }
  `}
`;

export const InnerContainerStyled = styled.div`
  width: 100%;
`;

export const InnerFlexContainerStyled = styled(InnerContainerStyled)`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
`;
